<template>
  <div class="company-profile-page">
    <div class="profile-cosmos" aria-hidden="true">
      <i></i><i></i><i></i><i></i><i></i><i></i>
    </div>

    <header class="profile-header">
      <a class="profile-brand profile-home-link" href="/" aria-label="返回宇宙之幂官网首页">
        <img
          class="company-profile-logo profile-title-logo"
          src="/assets/brand/logo-4572.1-128.webp"
          alt="宇宙之幂动态 Logo"
          width="58"
          height="58"
          draggable="false"
        >
        <span class="profile-brand-copy">
          <strong>宇宙之幂</strong>
          <i aria-hidden="true">|</i>
          <b lang="en">UniversePower</b>
        </span>
      </a>
      <a class="profile-back-link" href="/">返回官网首页</a>
    </header>

    <main class="profile-main">
      <section class="company-profile-hero" aria-labelledby="profileTitle">
        <span class="profile-kicker">UNIVERSE POWER · COMPANY PROFILE</span>
        <h1 id="profileTitle">宇宙之幂简介</h1>
        <p>宇宙之幂（深圳）科技集团有限公司</p>
        <span class="hero-light" aria-hidden="true"></span>
      </section>

      <div class="profile-sections">
        <section class="profile-card profile-intro" aria-labelledby="companyIntroTitle">
          <span class="card-index">01</span>
          <div class="card-heading">
            <span>COMPANY</span>
            <h2 id="companyIntroTitle">公司简介</h2>
          </div>
          <p class="profile-copy">【宇宙之幂】拥有&lt;私域宇宙&gt;、&lt;现实宇宙&gt;、&lt;映射宇宙&gt;、&lt;平行宇宙&gt;、&lt;分类宇宙&gt;、&lt;支持宇宙&gt;，并拥有一切&lt;宇宙形态&gt;、&lt;宇宙意识&gt;、&lt;宇宙行为&gt;、&lt;宇宙力量&gt;、&lt;宇宙成品&gt;、&lt;宇宙内核&gt;。您可在【宇宙之幂】中快速创造、实现一切目标、产品、愿望。</p>
        </section>

        <section class="profile-card profile-sites" aria-labelledby="officialSitesTitle">
          <span class="card-index">02</span>
          <div class="card-heading">
            <span>OFFICIAL SITES</span>
            <h2 id="officialSitesTitle">全球官网</h2>
          </div>
          <div class="official-site-grid">
            <a class="official-site-link" href="https://universe.top/" target="_blank" rel="noopener noreferrer">universe.top</a>
            <a class="official-site-link" href="https://universepower.top/" target="_blank" rel="noopener noreferrer">universepower.top</a>
            <a class="official-site-link" href="https://universepower.cn/" target="_blank" rel="noopener noreferrer">universepower.cn</a>
            <a class="official-site-link" href="https://宇宙.shop/" target="_blank" rel="noopener noreferrer">宇宙.shop</a>
            <a class="official-site-link" href="https://宇宙.live/" target="_blank" rel="noopener noreferrer">宇宙.live</a>
            <a class="official-site-link" href="https://宇宙之幂.中国/" target="_blank" rel="noopener noreferrer">宇宙之幂.中国</a>
            <a class="official-site-link" href="https://奇点.top/" target="_blank" rel="noopener noreferrer">奇点.top</a>
            <a class="official-site-link" href="https://宙.top/" target="_blank" rel="noopener noreferrer">宙.top</a>
          </div>
        </section>

        <section class="profile-card profile-offices" aria-labelledby="officesTitle">
          <span class="card-index">03</span>
          <div class="card-heading">
            <span>OFFICES</span>
            <h2 id="officesTitle">全国办公地址</h2>
          </div>
          <div class="office-list">
            <article>
              <span>全国总部</span>
              <h3>深圳</h3>
              <p>深圳市南山区粤海街道深圳湾科技生态园12栋B座52层整层。</p>
            </article>
            <article>
              <span>研发中心</span>
              <h3>北京</h3>
              <p>北京市朝阳区东三环南路58号院富顿中心（劲松桥北）。</p>
            </article>
            <article>
              <span>研发中心</span>
              <h3>天津</h3>
              <p>天津市滨海新区迎宾大道响螺湾中心商务区。</p>
            </article>
          </div>
        </section>

        <section class="profile-card profile-product" aria-labelledby="productTitle">
          <span class="card-index">04</span>
          <div class="card-heading">
            <span>MAIN PRODUCT</span>
            <h2 id="productTitle">主营产品</h2>
          </div>
          <div class="product-content">
            <div class="product-logo-wrap">
              <span class="product-orbit" aria-hidden="true"></span>
              <img
                class="company-profile-logo product-logo"
                src="/assets/brand/logo-4572.1-128.webp"
                alt="宇宙之幂产品动态 Logo"
                width="190"
                height="190"
                draggable="false"
              >
            </div>
            <div class="product-copy">
              <span class="product-label">产品名称</span>
              <h3>宇宙之幂 <i aria-hidden="true">|</i> <b lang="en">UniversePower</b></h3>
              <p class="profile-copy">【宇宙之幂】拥有&lt;私域宇宙&gt;、&lt;现实宇宙&gt;、&lt;映射宇宙&gt;、&lt;平行宇宙&gt;、&lt;分类宇宙&gt;、&lt;支持宇宙&gt;，并拥有一切&lt;宇宙形态&gt;、&lt;宇宙意识&gt;、&lt;宇宙行为&gt;、&lt;宇宙力量&gt;、&lt;宇宙成品&gt;、&lt;宇宙内核&gt;。您可在【宇宙之幂】中快速创造、实现一切目标、产品、愿望。</p>
            </div>
          </div>
        </section>
      </div>
    </main>

    <footer class="profile-footer">
      <span>宇宙之幂（深圳）科技集团有限公司</span>
      <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">粤ICP备2024237244号</a>
    </footer>
  </div>
</template>

<script>
import { installImageProtection } from '@/lib/imageProtection'

export default {
  name: 'CompanyProfile',
  mounted () {
    this.removeImageProtection = installImageProtection(document)
  },
  beforeDestroy () {
    if (this.removeImageProtection) this.removeImageProtection()
  }
}
</script>



// WEBPACK FOOTER //
// src/about/CompanyProfile.vue